import { render, staticRenderFns } from "./FaqFeedbackActions.vue?vue&type=template&id=c00f257e"
import script from "./FaqFeedbackActions.vue?vue&type=script&lang=js"
export * from "./FaqFeedbackActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports